import { useUserStore } from '@common/stores/userStore'

export function useDailyFrequency() {
  const userStore = useUserStore()
  const getNow = () => {
    const serverTime = userStore.serverTime
    let now = new Date().toJSON().slice(0, 10)
    if (/^\d{4}-\d{2}-\d{2}/.test(serverTime)) {
      now = serverTime.slice(0, 10)
    }
    return now
  }
  const setDailyFrequency = (cacheKey: string) => {
    localStorage.setItem(cacheKey, getNow())
  }
  const isEarlyThanToday = (dateStr?: string | null) => {
    return !dateStr || dateStr < getNow()
  }
  return {
    setDailyFrequency,
    isEarlyThanToday,
    getNow
  }
}
